import dayjs from 'dayjs';

import { Grid, GridItem, useTheme } from '@chakra-ui/react';

import { AccountPaymentInformation } from 'types';

import {
  CardExpiration,
  CardImage,
  CardNumber,
  CardSelect,
  CardUserDetails
} from 'ui/CardsContent';

interface PaymentCCardItemProps {
  card: AccountPaymentInformation;
  onSelectCard: () => void;
  isActive: boolean;
  isMembershipFlow?: boolean;
  isLast: boolean;
}

const PaymentCCardItem = ({
  card,
  onSelectCard,
  isActive,
  isMembershipFlow = false,
  isLast = false
}: PaymentCCardItemProps) => {
  const {
    colors: {
      palette: {
        components: { paymentList }
      }
    }
  } = useTheme();

  const isCurrentMonth =
    dayjs().month() + 1 === card.exp_month && dayjs().year() === card.exp_year;

  return (
    <Grid
      px={{ base: '16px', md: '30px' }}
      py={{ base: '12px', md: '14px' }}
      templateColumns={{ base: 'repeat(3, 1fr)', md: 'repeat(12, 1fr)' }}
      columnGap='10px'
      backgroundColor={paymentList.cardBg}
      borderRadius={isMembershipFlow ? 0 : '6px'}
      borderBottomWidth={isMembershipFlow && !isLast ? 1 : 0}
      borderBottomColor={paymentList.itemDivider}
      alignItems='center'
      h='92px'
      w='full'
    >
      <GridItem colSpan={1}>
        <CardSelect
          onClick={onSelectCard}
          isActive={isActive}
          bg={paymentList.buttonBg}
          activeBg={paymentList.buttonActiveBg}
          activeBorder={paymentList.buttonActiveBorderColor}
          activeColor={paymentList.buttonActiveColor}
        />
      </GridItem>

      <GridItem
        colSpan={{ base: 1, md: 2 }}
        pl={{ base: '11px', sm: '21px', lg: '41px' }}
      >
        <CardImage src={card.icon} alt={card.cctypename} />
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <CardNumber
          color={paymentList.cardNumberColor}
          cardNumber={card.card_number}
        />
      </GridItem>

      <GridItem
        colStart={7}
        colSpan={4}
        display={{ base: 'none', md: 'block' }}
      >
        <CardUserDetails
          color={paymentList.cardOwnerColor}
          owner={card.owner}
          street={card.addr_ln1}
          address={
            card.city && card.state && card.zip
              ? `${card.city}, ${card.state}, ${card.zip}`
              : ''
          }
        />
      </GridItem>

      <GridItem
        colStart={11}
        colSpan={2}
        display={{ base: 'none', md: 'block' }}
      >
        <CardExpiration
          isCurrentMonth={isCurrentMonth}
          color={
            isCurrentMonth
              ? paymentList.cardExpErrorColor
              : paymentList.cardExpColor
          }
          month={card.exp_month}
          year={card.exp_year}
        />
      </GridItem>
    </Grid>
  );
};

export default PaymentCCardItem;
